import { BarChart3, Building2, LayoutTemplate, MessageSquareText, Search, Sparkles, Star } from 'lucide-react';

/* Seven product categories. Each maps to real Data Tallied capabilities. */
export const PRODUCTS = [
  {
    slug: 'profile',
    icon: Building2,
    name: 'Profile Management',
    eyebrow: 'PROFILE MANAGEMENT & OPTIMIZATION',
    tagline: 'Show up where local customers are already searching.',
    summary: 'Keep your business profile accurate and active — categories, hours, services, and photos — and track how it performs over time.',
    startsOn: 'launch',
    features: [
      'Business profile performance tracking',
      'Guided Google Business Profile setup',
      'Hours, services, and category accuracy checks',
      'Media and photo readiness',
      'Weekly optimization checklist',
    ],
    outcomes: ['More profile views', 'More direction requests', 'More calls from search'],
    related: 'local-visibility',
  },
  {
    slug: 'search',
    icon: Search,
    name: 'Local Search & Rankings',
    eyebrow: 'LOCAL SEARCH & RANK TRACKING',
    tagline: 'Know exactly where you rank — and where you don’t.',
    summary: 'Track Maps and organic positions by keyword and market with a neighborhood-level grid, and turn ranking gaps into a plan.',
    startsOn: 'launch',
    features: [
      'Grid rank tracker for map visibility',
      'Keyword rank tracker across Maps and Search',
      'Location and market comparisons',
      'Local SEO Page Writer (AI Studio)',
      'Shareable ranking evidence',
    ],
    outcomes: ['Higher map pack placement', 'More first-page keywords', 'Clear proof of progress'],
    related: 'local-visibility',
  },
  {
    slug: 'reviews',
    icon: Star,
    name: 'Reviews & Reputation',
    eyebrow: 'REVIEW MANAGEMENT',
    tagline: 'Build the reputation that wins customers before they call.',
    summary: 'Generate a steady stream of new reviews and respond professionally in minutes — without inventing a single word.',
    startsOn: 'launch',
    features: [
      'Review request links and QR codes',
      'Automated review requests after service (Growth)',
      'Review Response Assistant (AI Studio)',
      'Reputation dashboard (Revenue Partner)',
      'Response-time monitoring',
    ],
    outcomes: ['More 5-star reviews', 'Faster responses', 'Stronger local trust'],
    related: 'ai-studio',
  },
  {
    slug: 'social',
    icon: MessageSquareText,
    name: 'Social Media',
    eyebrow: 'SOCIAL MEDIA MANAGEMENT',
    tagline: 'Posts that sound like you wrote them.',
    summary: 'Plan a realistic publishing rhythm and generate on-brand posts for every network from one calendar.',
    startsOn: 'growth',
    features: [
      'Social content calendar',
      'Social Content Planner (AI Studio)',
      'Scheduled marketing campaigns',
      'Campaign Writer for coordinated posts',
      'Per-network post drafting',
    ],
    outcomes: ['Consistent posting', 'Less time per post', 'A recognizable brand voice'],
    related: 'ai-studio',
  },
  {
    slug: 'website',
    icon: LayoutTemplate,
    name: 'Website & Pages',
    eyebrow: 'WEBSITE DEVELOPMENT',
    tagline: 'A site built to convert local traffic.',
    summary: 'Generate and edit a fast, mobile-ready website with live preview and HTML export, plus landing pages for each service.',
    startsOn: 'launch',
    features: [
      'AI Website Builder with live preview',
      'Downloadable, responsive HTML',
      'Service and location landing pages',
      'Lead capture forms',
      'Digital business cards',
    ],
    outcomes: ['Faster load times', 'More mobile conversions', 'Pages for every service'],
    related: 'ai-studio',
  },
  {
    slug: 'reports',
    icon: BarChart3,
    name: 'Reporting',
    eyebrow: 'MONTHLY REPORTING',
    tagline: 'Clear reports. No jargon.',
    summary: 'See what actually produces customers — sources, response speed, campaign performance, and revenue — in plain English.',
    startsOn: 'growth',
    features: [
      'Campaign performance dashboard',
      'Lead source tracking',
      'Response-time tracking (Revenue Partner)',
      'Revenue and conversion reporting',
      'Source profitability comparison',
    ],
    outcomes: ['Know your best sources', 'Spot slow responses', 'Map effort to revenue'],
    related: 'how-it-works',
  },
  {
    slug: 'ai-visibility',
    icon: Sparkles,
    name: 'AI Visibility Studio',
    eyebrow: 'AI GROWTH STUDIO',
    tagline: 'Fifteen assistants trained on your real business context.',
    summary: 'Build pages, campaigns, responses, forms, workflows, and revenue plans with AI — every draft saved to your account.',
    startsOn: 'launch',
    features: [
      '15 focused AI assistants',
      'Website, SEO, and poster builders',
      'Campaign, social, and follow-up writers',
      'Workflow, qualifier, and intake builders (Business)',
      'Revenue recovery and funnel tools (Revenue Partner)',
    ],
    outcomes: ['Usable drafts in minutes', 'Nothing invented', 'Everything saved to your account'],
    related: 'ai-studio',
  },
];

export const findProduct = slug => PRODUCTS.find(product => product.slug === slug);
